// extracted by mini-css-extract-plugin
export default {"container":"EnteringName_container__r5bA+","title":"EnteringName_title__XbEFV","text":"EnteringName_text__kW338","input":"EnteringName_input__FASTd"};